'use client';

import FilterIcon from '@repo/ui/src/components/Icons/FilterIcon';
import { useState } from 'react';
import FilterDrawer from './_FilterDrawer';

const GridHeader = ({ filters, currentFilters, setFilters, clearFilters, nbHits }) => {
  const [filtersOpen, setFiltersOpen] = useState(false);

  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-py-4 tw-px-8">
      <div>
        {filters && (
          <>
            <button onClick={() => setFiltersOpen(true)} className="tra-text-web-body-xl">
              <FilterIcon aria-hidden className="tw-mr-[1ch]" />
              Filters
            </button>
            <FilterDrawer
              open={filtersOpen}
              onClose={() => setFiltersOpen(false)}
              filters={filters}
              currentFilters={currentFilters}
              setFilters={setFilters}
              clearFilters={clearFilters}
            />
          </>
        )}
      </div>
      <p className="tra-text-web-body-xl">{`${nbHits || '0'} Result${nbHits === 1 ? '' : 's'}`}</p>
    </div>
  );
};

export default GridHeader;
